module.exports = __webpack_public_path__ + "static/media/bg3@2x.9daf93d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/bg3@2x.png
// module id = 400
// module chunks = 0